import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdEmail, MdLockOutline } from 'react-icons/md';
import { FaSignInAlt } from 'react-icons/fa';
import { SiShopify } from 'react-icons/si';

const AdminLogin = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = (e) => {
        e.preventDefault();

        const validCredentials = [
            { email: 'lbnmp@gmail.com', password: 'lbnmp' },
        ];

        const matchedUser = validCredentials.find(
            (cred) => cred.email === email && cred.password === password
        );

        if (matchedUser) {
            setError('');
            sessionStorage.setItem('isAdminLoggedIn', 'true');
            sessionStorage.setItem('adminEmail', matchedUser.email);
            window.alert('✅ Admin login successful!');
            navigate('/admin-dashboard');
        } else {
            setError('Invalid email or password');
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                <div style={styles.header}>
                    {/* <SiShopify size={55} color="#faae2f" /> */}
                    <h1 style={styles.mainTitle}>LBN Market Place</h1>
                    <p style={styles.subTitle}>Admin  Login</p>
                </div>

                <form onSubmit={handleLogin}>
                    <div style={styles.inputWrapper}>
                        <MdEmail style={styles.icon} />
                        <input
                            type="email"
                            placeholder="Admin Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            style={styles.input}
                        />
                    </div>
                    <div style={styles.inputWrapper}>
                        <MdLockOutline style={styles.icon} />
                        <input
                            type="password"
                            placeholder="Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            style={styles.input}
                        />
                    </div>

                    {error && <p style={styles.error}>{error}</p>}

                    <button type="submit" style={styles.button}>
                        <FaSignInAlt style={{ marginRight: '8px' }} />
                        Login to Dashboard
                    </button>
                </form>
            </div>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      background: '#f8f9fa',

        padding: '20px',
    },
    card: {
        background: '#fff',
        padding: '45px 35px',
        borderRadius: '14px',
        boxShadow: '0 18px 40px rgba(0, 0, 0, 0.15)',
        maxWidth: '420px',
        width: '100%',
        textAlign: 'center',
    },
    header: {
        marginBottom: '30px',
    },
    mainTitle: {
        marginTop: '15px',
        marginBottom: '5px',
        fontSize: '26px',
        fontWeight: '700',
        color: '#025299',
        fontFamily: 'Segoe UI, sans-serif',
    },
    subTitle: {
        fontSize: '15px',
        color: '#718096',
        fontWeight: '500',
    },
    inputWrapper: {
        position: 'relative',
        marginBottom: '20px',
    },
    icon: {
        position: 'absolute',
        top: '13px',
        left: '14px',
        color: '#A0AEC0',
        fontSize: '18px',
    },
    input: {
        width: '85%',
        padding: '12px 12px 12px 40px',
        borderRadius: '8px',
        border: '1px solid #CBD5E0',
        fontSize: '15px',
        outline: 'none',
        transition: 'border 0.3s ease',
    },
    error: {
        color: '#e53e3e',
        marginBottom: '12px',
        fontSize: '14px',
        fontWeight: '500',
    },
    button: {
        width: '100%',
        padding: '12px',
        background: '#faae2f',
        color: '#fff',
        border: 'none',
        borderRadius: '8px',
        fontWeight: 'bold',
        fontSize: '15px',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'background 0.3s ease',
    },
};

export default AdminLogin;
